// src/functions/user.js
import axios from 'axios';

// ฟังก์ชันสำหรับสร้างผู้ใช้
export const addMemberData_API = async (token, group) => {
    const url = `${process.env.REACT_APP_API}/addMemberData`;
    const headers = { authToken: token };
    const data = { memberData: group };
    try {
        const response = await axios.post(url, data, { headers });
        return response.data;
    } catch (error) {
        console.error("Error creating person:", error);
        // โยน error กลับไปให้ catch ในที่เรียกใช้ addFromCamera_API()
        throw error.response ? error.response : new Error("Unknown error");
    }
};
export const listMemberData_API = async (token, userId) => {
    const url = `${process.env.REACT_APP_API}/listMemberData`;
    const headers = { authToken: token };
    const data = { userId: userId };
    try {
        const response = await axios.post(url, data, { headers });
        return response.data;
    } catch (error) {
        console.error("Error creating person:", error);
        // โยน error กลับไปให้ catch ในที่เรียกใช้ addFromCamera_API()
        throw error.response ? error.response : new Error("Unknown error");
    }
};

export const removeMemberData_API = async(token,data)=>{
    const url = `${process.env.REACT_APP_API}/remove-memberData_API`;
    const headers = { authToken: token }; // ตรวจสอบว่า 'null' เป็นสตริงที่ถูกต้องหรือไม่
    const fromdata = {data:data}
    try {
        const response = await axios.post(url, fromdata, { headers });
        return response.data;
    } catch (error) {
        console.error("Error creating person:", error);
        throw error.response ? error.response : new Error("Unknown error");
    }
}

export const updateMemberData_API = async (token, memberData) => {
    const url = `${process.env.REACT_APP_API}/updateMemberData`;
    const headers = { authToken: token };
    const data = { memberData };
    try {
        const response = await axios.post(url, data, { headers });
        return response.data;
    } catch (error) {
        console.error("Error updating member:", error);
        throw error.response ? error.response : new Error("Unknown error");
    }
};
export const checkVehicleNumber_API = async (token, villageId, vehicleNumber, memberId = null) => {
    const url = `${process.env.REACT_APP_API}/checkVehicleNumber`;
    const headers = { authToken: token };
    const data = { villageId, vehicleNumber, memberId };
    try {
        const response = await axios.post(url, data, { headers });
        return response.data;
    } catch (error) {
        console.error("Error checking vehicle number:", error);
        throw error.response ? error.response : new Error("Unknown error");
    }
};
export const getProfile_API = async (token) => {
    const url = `${process.env.REACT_APP_API}/profile`;
    const headers = { authToken: token };
    try {
        const response = await axios.get(url, { headers });
        return response.data;
    } catch (error) {
        console.error("Error fetching profile:", error);
        throw error.response ? error.response : new Error("Unknown error");
    }
};
export const exportMemberData = async (token, user) => {
    const url = `${process.env.REACT_APP_API}/export-member-data`;
    const headers = { authToken: token };
    const data = { user };


    try {
        const response = await axios.post(url, data, { headers, responseType: 'blob' });

        // สร้าง Blob จากข้อมูลที่ได้รับ
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // สร้างลิงก์ดาวน์โหลด
        const link = document.createElement('a');
        const fileUrl = window.URL.createObjectURL(blob);

    // ตั้งชื่อไฟล์ให้กับการดาวน์โหลด (ใช้ id หรือ email หากมี)
    link.href = fileUrl;
    const namePart = (user && (user.id || user.email)) ? (user.id || user.email) : 'export';
    link.setAttribute('download', `member_data_${namePart}.xlsx`);

        // เพิ่มลิงก์ลงใน DOM และคลิกเพื่อดาวน์โหลด
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);  // ลบลิงก์หลังจากคลิกดาวน์โหลด

    } catch (error) {
        console.error("Error exporting member data:", error);
        // ให้ caller รู้ว่าเกิดข้อผิดพลาด
        throw error.response ? error.response : new Error("Unknown error");
    }

    // แจ้งกลับไปยัง caller ว่าสำเร็จและดาวน์โหลดเริ่มแล้ว
    return { success: true };
};

// ========== API Token Management ==========

/** POST /api/profile/api-token — สร้าง API token ใหม่ บันทึกลง Village */
export const generateApiToken_API = async (token, password) => {
    const url = `${process.env.REACT_APP_API}/profile/api-token`;
    const headers = { authToken: token };
    try {
        const response = await axios.post(url, { password }, { headers });
        return response.data;
    } catch (error) {
        console.error('Error generating API token:', error);
        throw error.response?.data || error.response || new Error('Unknown error');
    }
};

/** DELETE /api/profile/api-token — ยกเลิก API token */
export const revokeApiToken_API = async (token) => {
    const url = `${process.env.REACT_APP_API}/profile/api-token`;
    const headers = { authToken: token };
    try {
        const response = await axios.delete(url, { headers });
        return response.data;
    } catch (error) {
        console.error('Error revoking API token:', error);
        throw error.response ? error.response : new Error('Unknown error');
    }
};
